import apiFetch from '../apiFetch'

export default function (token, financingTypeProduct) {
  return apiFetch({ endPoint: 'FinancingTypeProduct/Update/', method: 'POST', body: financingTypeProduct, token: token })
}
